require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-09-24-the-economy.json") })
        }
      }, "path---articles-2008-09-24-the-economy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-09-24-the-economy!./.cache/json/articles-2008-09-24-the-economy.json
// module id = 550
// module chunks = 231608221292675